import { useState } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Textbox from '@bequestinc/wui/input/textbox';

const PasswordField = ({ value, onChange, error, name = 'password', label = 'Password' }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => setShowPassword(show => !show);

  return (
    <Textbox
      name={name}
      type={showPassword ? 'text' : 'password'}
      label={label}
      autoComplete="off"
      value={value}
      onChange={onChange}
      error={error}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={showPassword ? 'hide the password' : 'display the password'}
              onClick={handleShowPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

PasswordField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
};

PasswordField.defaultProps = {
  error: null,
  name: 'password',
  label: 'Password',
};

export default observer(PasswordField);
